import React from 'react';
import styles from './styles.module.scss';

const Tos = () => (
  <div className={styles.tos}>
    <div className="container">
      <div className="row">
        <div className="col">
          <h1>Unyted Privacy Policy &amp; Terms of Use</h1>
          <p>
            Hello! This is where we keep our Privacy Policy and Terms of Use. It
            describes what information we collect through any mobile apps and
            our website, and how we use this information. Our Privacy Policy was
            last updated on August 7, 2019.
          </p>
          <h2>Commitment to Privacy</h2>
          <p>
            The information we collect through our website helps us provide you
            with information specifically-tailored to your needs and interests.
            This privacy policy (the “Privacy Policy”) covers the Unyted website
            and all its features (hereinafter referred to as the “Community” or
            “Website”). Please read below to review our Privacy Policy and the
            types of information we gather through the Website. In this Privacy
            Policy, “we”, “us”, “our” and other similar references mean Unyted,
            and “you” and “your” and other similar references mean a specific
            user of the Website (hereinafter also referred to as a “Community
            Member” or “Website User.”)
          </p>
          <h2>Application and Consent</h2>
          <p>
            By authenticating to our Website and/or becoming part of the Unyted
            Community, you accept the practices described in this Privacy
            Policy. Specifically, you consent to the collection and use of
            certain information as described herein. The Website’s Privacy
            Policy does not apply to information collected in any other way,
            including outside of the Website.
          </p>
          <h2>What type of information do we collect?</h2>
          <h3>(a) General Information</h3>
          <p>
            When you visit the Website, we collect certain information by
            automated or electronic means, using technologies such as cookies,
            pixel tags and web beacons, browser analysis tools, and web server
            logs. As you use the Website and its applications, your browser and
            devices communicate with servers operated by us, our business
            partners, and services providers to coordinate and record the
            interactivity and fill your requests for services and information.
          </p>
          <p>
            The Website, may, at our sole discretion, send one or more cookies
            (a small file containing a string of characters) to your computer
            that uniquely identifies your browser and stores other information
            relevant to your account. Cookies can make it easier for you to log
            on to and use the Website during future visits. You can configure
            your browser to accept all cookies, reject all cookies, or notify
            you when a cookie is set. (Each browser is different, so please
            check the “Help” menu of your browser to learn how to change your
            cookie preferences.)
          </p>
          <p>
            In many cases, the information we collect using cookies and other
            tools is used in nonidentifiable ways, without any reference to your
            Personal Information. For example, we may use information we collect
            about Community Members and Website Users to optimize the Website
            and understand its traffic and usage patterns. In other cases, we
            may associate the information we collect using cookies and related
            technologies with Personal Information. In the latter, this Privacy
            Policy governs how we use that information. In addition, if the
            settings on your location-aware device allow us to receive location
            Information, we will collect that automatically. If we associate
            this location Information with other personal information, this
            Privacy Policy governs how we would use that information too.
          </p>
          <h3>(b) Personal Information</h3>
          <p>
            For the purposes of this Privacy Policy, "Personal Information" is
            any information that identifies you, would enable someone to contact
            you, or that describes your relationship with Unyted and the Website
            Community. We collect and store Personal Information when you
            register to use the Website, ask a question, complete a form,
            participate in a discussion, make an entry, conduct a transaction,
            or send us an email. While you are not required to submit any
            information to the Website, if you do not provide the requested
            information, you may not be able to access or use some of the
            features and functions of the Website, and we may not be able to
            provide you with certain services.
          </p>
          <h3>(c) Community Information</h3>
          <p>
            The Website may contain forums, blogs, articles, boards, and other
            interactive areas where you may be able to publicly post
            information, communicate with others, review products and merchants,
            and submit media content. Prior to posting in these areas, please
            read our Terms of Use and this Privacy Policy carefully. Any
            information you post in a chat will be accessible to anyone with
            Internet access, and any Personal Information you include in your
            posting may be read, collected, and used by others. For example, if
            you post your email address while sharing information on a blog, you
            may receive unsolicited messages from other parties. Please avoid
            publicly posting Personal Information. If you have questions about
            Personal Information posted in our Communities, please contact
            info@unyted.co
          </p>
          <h2>How do we protect the information we collect?</h2>
          <p>
            Unyted uses physical, electronic, and administrative safeguards to
            assist us in preventing unauthorized access, maintaining data
            accuracy, and correctly using your Personal Information. Except as
            specified in this Privacy Policy, we use commercially reasonable
            efforts to limit access to your Personal Information to our
            employees, agents, and officers who need the information for their
            jobs. Access to information is limited (through user/password
            credentials) to those employees who require such access to perform
            their job functions. We use industry-standard Secure Socket Layer
            (SSL) encryption technology to safeguard the account registration
            process and sign-up information. Other security safeguards include
            but are not limited to data encryption, firewalls and physical
            access controls to building and files. All information you provide
            to us is backed up on a regular basis.
          </p>
          <p>
            While the Website employs reasonable technical and organizational
            security measures to protect the loss, misuse or alteration of
            information under our control, we cannot guarantee that unauthorized
            third parties will never be able to defeat those security measures
            or use your Personal Information for improper purposes.
          </p>
          <h2>How do we use the information we collect?</h2>
          <p>
            Unyted may use the information collected from the Website to do any
            of the following:
          </p>
          <ul>
            <li>Operate and improve the Website and Community functions;</li>
            <li>
              Evaluate the types of offers, products or services that may be of
              interest to Community Members and Website Users, and determine
              customer eligibility for same;
            </li>
            <li>
              Facilitate and track incicents for Unyted and other related
              security analytics;
            </li>
            <li>Provide customer support;</li>
            <li>
              Communicate and provide additional information that may be of
              interest to Community Members and Website Users about Unyted
              platform updates or changes in service;
            </li>
            <li>
              Manage our everyday business needs, such as Website
              administration, forum management, fulfillment, analytics, fraud
              prevention, enforcement of our corporate reporting obligations,
              and allow you to apply for a job, post a video or sign up for
              special offers from third parties through the Site.
            </li>
          </ul>
          <p>
            Unyted representations regarding information collected from the
            Website to do any of the following:
          </p>
          <ul>
            <li>
              Unyted will not sell any of your users’ personal information
            </li>
            <li>
              Unyted will not share any of your users’ personal information with
              3rd parties other than to provide our educational service
            </li>
            <li>
              Unyted will not share any of your users’ personal information with
              3rd parties other than to provide our educational service
            </li>
          </ul>
          <p>
            In the abundance of caution, please see further representations:
          </p>
          <ul>
            <li>
              Data stored with Unyted is also encrypted at rest, including all
              database backups using keys that only authorized individuals have
              access to
            </li>
            <li>
              Only authorized individuals have access to production data and our
              source code.
            </li>
            <li>
              All of the tools used by Unyted for quality assurance have similar
              or even tighter security practices
            </li>
            <li>
              Unyted never shares PII with 3rd parties for the purposes of
              research or financial gain and all data gathered remains with
              Unyted
            </li>
            <li>
              Compiled data may be used improve the platform performance and our
              direct services.
            </li>
          </ul>
          <h2>How can you control your information?</h2>
          <p>
            To manage your information, please see the limited “Account
            Settings.” You may choose to subscribe to some types of messages,
            and may choose to unsubscribe from others. You may update your user
            information preferences from time to time. Please note that even if
            you change or alter authentication/login information, our service
            may be interrupted.
          </p>
          <h2>We cannot control information you submit to external links</h2>
          <p>
            This Privacy Policy only addresses the use and disclosure of
            information by Unyted through your interaction with the Website.
            Other websites that may be accessible through links from our Website
            may have their own privacy statements and personal information
            collection, use, and disclosure practices. We encourage you to
            familiarize yourself with the privacy statements provided by these
            other parties prior to providing them with information or otherwise
            using their website and/or product or service.
          </p>
          <p>
            We are not responsible for how these other companies or
            organizations collect, use, disclose, or secure the information that
            you provide them. If you choose to access a third party website
            linked to our Website, you do so at your own risk and subject to any
            terms of service or privacy policy (if any) associated with such
            third party sites.
          </p>
          <h2>Children under 13</h2>
          <h3>Children’s Online Privacy Protection Act (“COPPA”)</h3>
          <p>
            We are committed to protecting your personal information and
            satisfying the spirit as well as the letter of all applicable legal
            requirements, including the Children’s Online Privacy Protection Act
            (“COPPA”) and the Family Educational Rights and Privacy Act
            (“FERPA”), through our compliance with this Privacy Policy.
          </p>
          <p>
            By submitting personal information through our Sites, Apps or
            Services, you expressly consent to the processing of your personal
            information in accordance with this Privacy Policy and represent
            your school is within authorization necessary. We shall limit the
            use of personal information collected through our Services to the
            purposes described in this Privacy Policy.
          </p>
          <p>
            For more information about the Children's Online Privacy Protection
            Act (COPPA), visit http://www.coppa.org/.
          </p>
          <h2>Contact Us</h2>
          <p>
            If users have any questions or suggestions regarding our Privacy
            Policy, please contact us at info@unyted.co.
          </p>
          <h2>Updates &amp; Modifications to Privacy Policy</h2>
          <p>
            From time to time, we may update this Privacy Policy to clarify our
            practices or to reflect new or different privacy practices, such as
            when we add new features or functions to the Website. If we make any
            material changes, we will notify you by email (sent to the email
            address specified in your account) or by means of notice on the
            Website prior to the change becoming effective. We encourage you to
            periodically review this page for the latest information about our
            privacy practices.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default Tos;
